import { useMutation } from '@apollo/client'
import { AddEventInvoice, AddEventInvoiceVariables } from '../../types'
import { ADD_EVENT_INVOICE } from './operations'

export const addEventInvoice = () => useMutation<
  AddEventInvoice,
  AddEventInvoiceVariables
>(ADD_EVENT_INVOICE)
